import { useEffect, useRef, useState } from 'react'
import * as React from 'react'

type useExpendBtnType = (
  skip?: boolean,
) => [boolean, React.RefObject<HTMLDivElement>, () => void, () => void]

const useExpendBtn: useExpendBtnType = (skip = false) => {
  const [isExpended, setIsExpended] = useState(false)
  const targetRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (skip === true) {
      setIsExpended(true)
    } else if (targetRef.current) {
      setIsExpended(
        targetRef.current.scrollHeight <= targetRef.current.clientHeight,
      )
    }
  }, [targetRef, skip])
  const handleClick = () => {
    setIsExpended(true)
  }
  const handleCancleClick = () => {
    setIsExpended(false)
  }
  return [isExpended, targetRef, handleClick, handleCancleClick]
}

export default useExpendBtn
